// Content equality for the toolbar's id-list filters (selected accounts, selected payment days).
// Both filters write their selection back through a `setToolbarFilters` updater that must return
// `prev` unchanged when nothing actually changed: BankFeedGrid observes `toolbarFilters` by object
// identity, so a fresh-but-equal array would trigger a cursor reset + purge refresh — and, from
// inside a seeding effect, an endless seed → refetch → seed loop.
//
// Order-insensitive on purpose: both call sites treat the selection as a set.
export const sameIds = (a: string[], b: string[]) =>
  a.length === b.length && a.every((id) => b.includes(id));
